import { Button, Checkbox } from "antd";
import SignatureCanvas from 'react-signature-canvas'
import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Config from "../../../Config";

import "./mrtt_client_screen.css";
import GeneralBloc from "../../../bloc/general_bloc";
import UtilBloc from "../../../bloc/util_bloc";
import { ReactComponent as ProposalIcon } from "../../../Proposal2.svg";
import { ReactComponent as DeclarationIcon } from "../../../Declaration.svg";
import { ReactComponent as SignIcon } from "../../../Draft.svg";
import AppModal from "../../component/app_modal/app_modal";
import ClientBloc from "../../../bloc/client_bloc";
import ProposalBloc from "../../../bloc/mrtt_proposal_bloc";
import App_mobile_loading from "../../dialog/app_mobile_loading";
import AppSelectField from "../../component/app_select_field/app_select_field";
import FormsBloc from "../../../bloc/forms_bloc";

class ReviewSignature extends Component {
    constructor(props) {
        super(props);
        this.state = {
            client: Config.context,
            userDataHeader: null,
            userSettings: {},
            consentDetails: { answers: [] },
            confirmSignature: false,
            signatureContent: null,
            cancelModalOpen: false,
        };
        this.sigpad = {}
    }

    clear = () => {
        this.sigPad.clear();
        this.setState({ signatureContent: null });
    }

    saveSignature = () => {
        console.log("save")
        let strImage = this.sigPad.getTrimmedCanvas().toDataURL('image/png')
        let signatureContent = strImage.split("base64,")[1];
        this.setState({ signatureContent: signatureContent })
    }


    getProposalId() {
        return this.props.match.params.itemId;
    }

    componentDidMount() {
        this.setInitialData();
    }

    async setInitialData() {
        this.setState({ loading: true });
        let result = await ProposalBloc.getFormDetailProposal(this.getProposalId(), Config.formProposalDetailMapping[10].category, 'client');
        let stateList = await FormsBloc.getStateList('client');
        if (result.success) {
            console.log('heyy', result)
            this.setState({ consentDetails: result.data[0]?.proposal_attr.properties.answers, stateList: stateList?.data || [] });
        }
        this.setState({ loading: false });
    }

    handleCancelModalOpen() {
        this.setState({ cancelModalOpen: true });
    }

    handleCancelModalClose() {
        this.setState({ cancelModalOpen: false });
    }

    handleCancelReview() {
        window.location.replace(`/${this.state.client}/${Config.routes.generic.fwd + Config.routes.generic.mrtt}/${Config.routes.generic.client_auth}`)
    }

    handleValidation() {
        console.log(this.state.confirmSignature, this.state.signatureContent)
        if (this.state.confirmSignature && !UtilBloc.isNullOrEmpty(this.state.signatureContent) && !UtilBloc.isNullOrEmpty(this.state.placeOfSigning)) {
            return false;
        } else {
            return true;
        }
    }

    handleChecked(val) {
        this.setState({ confirmSignature: val });
    }

    async handleGoNext() {
        this.setState({ loading: true });
        // if (this.handleValidation()) {
        let strImage = this.state.signatureContent;
        let consentData = {
            answers: this.state.consentDetails
        };
        let signatureConsent = {
            status: this.state.confirmSignature == true ? 'Yes' : 'No',
            id: 'signatureConsent',
            compulsory: 'Yes',
            title: '',
            desc: ''
        };
        let signatureConsentExist = consentData.answers.findIndex(
            (item) =>
                item.id === 'signatureConsent'
        );
        signatureConsentExist !== -1 && consentData.answers.length > 0 && consentData.answers.map((item) => {
            if (item.id == 'signatureConsent') {
                item.status = this.state.confirmSignature == true ? 'Yes' : 'No'
            }
        })
        signatureConsentExist === -1 && consentData.answers.push(signatureConsent);
        console.log(strImage)
        let submitConsentResult = await ProposalBloc.saveFormProposal(this.getProposalId(), 'THIRD_PARTY_CONSENT', consentData, 'client');
        let submitSignatureResult = await ClientBloc.submitClientSignature(this.getProposalId(), { signature: strImage, placeOfSigning: this.state.placeOfSigning });

        if (submitConsentResult.success == true && submitSignatureResult.success == true) {
            console.log('check result', submitConsentResult, submitSignatureResult)
            window.location.replace(`/${this.state.client}/${Config.routes.generic.fwd + Config.routes.generic.mrtt}/${Config.routes.generic.client_review_success}/${this.getProposalId()}`)
        } else {
            this.setState({
                title: 'Notification',
                message: submitSignatureResult.message || submitConsentResult.message,
                isOpen: true
            })
        }

        // }
        this.setState({ loading: false });
    }

    handleGoBack() {
        window.location.replace(`/${this.state.client}/${Config.routes.generic.fwd + Config.routes.generic.mrtt}/${Config.routes.generic.client_review_declaration}/${this.getProposalId()}`)
    }

    showMessageModal = () => {
        return (
            <AppModal
                open={this.state.isOpen}
                handleModalClose={() => this.setState({ isOpen: false })}
                // width={'50%'}
                title={this.state.title}
                subtitle={this.state.message}
                positiveButtonText={'Close'}
                handlePositivePress={() => this.setState({ isOpen: false })}
                closable={false}
            />
        )
    }

    loadingContent() {
        return (
            <div style={{ height: "100%" }}>
                <App_mobile_loading isLoading={this.state.loading} />
            </div>
        );
    }

    stepHeader() {
        return (
            <>
                <div className="column d-flex align-items-center justify-content-center">
                    <div className="d-flex row pr-2">
                        <div className="align-items-center justify-content-center" style={{ textAlign: '-webkit-center' }}>
                            <div className="process_step">
                                <ProposalIcon fill={'#FFFFFF'} style={{ height: 24, width: 24 }} />
                            </div>
                            <div className="">Proposal</div>
                        </div>

                    </div>
                    <div className="line_through_complete" ></div>
                    <div className="d-flex row pr-2">
                        <div className="align-items-center justify-content-center" style={{ textAlign: '-webkit-center' }}>
                            <div className="process_step">
                                <DeclarationIcon fill={'#FFFFFF'} style={{ height: 24, width: 24 }} />
                            </div>
                            <div className="">Declaration</div>
                        </div>

                    </div>
                    <div className="line_through_complete"></div>
                    <div className="d-flex row p-2">
                        <div className="align-items-center justify-content-center" style={{ textAlign: '-webkit-center' }}>
                            <div className="process_step">
                                <SignIcon fill={'#FFFFFF'} style={{ height: 24, width: 24 }} />
                            </div>
                            <div className="">Signature</div>
                        </div>

                    </div>
                </div>
            </>
        )
    }

    renderBottomBar() {
        return (
            <div className="bottom_container d-flex justify-content-center">
                <Button
                    // disable={this.handleValidateMandatoryField()}
                    style={{
                        backgroundColor: 'transparent',
                        color: '#EE7623',
                        width: '50%',
                        height: 49,
                        border: '0px',
                    }}
                    onClick={() => this.handleCancelModalOpen()}
                >
                    Cancel
                </Button>
                <Button
                    disabled={this.handleValidation()}
                    style={{
                        backgroundColor: '#183028',
                        color: 'white',
                        width: '50%',
                        height: 49,
                        opacity: this.handleValidation() ? 0.7 : 1
                    }}
                    onClick={() => this.handleGoNext()}
                >
                    Submit
                </Button>
            </div>
        )
    }

    showMessageModal = () => {
        return (
            <AppModal
                open={this.state.isOpen}
                handleModalClose={() => this.setState({ isOpen: false })}
                // width={'50%'}
                title={this.state.title}
                subtitle={this.state.message}
                positiveButtonText={'Close'}
                handlePositivePress={() => this.setState({ isOpen: false })}
                closable={false}
            />
        )
    }

    render() {
        return (
            <div className="client_container" style={{ height: '100%' }}>
                {
                    this.state.loading && this.loadingContent()
                }
                <div className="mobile_container justify-content-center" style={{ height: window.innerHeight, overflowY: 'scroll' }}>
                    <div className="client_header justify-content-between px-4">
                        <img
                            src={
                                GeneralBloc.getAssetsContextPath() +
                                `/assets/icons/Back.svg`
                            }
                            onClick={() => this.handleGoBack()}
                            alt="Documents"
                            className=""
                            style={{ width: 15, height: 15, cursor: 'pointer' }}
                        />
                        Review and Sign
                        <div></div>
                    </div>
                    {this.renderBottomBar()}
                    <div className="d-flex justify-content-center p-4 row m-0 w-100">
                        {this.stepHeader()}
                        <div className="mt-4">
                            <div className="client_instruction_header">
                                Please provide your signature to proceed with the proposal.
                            </div>
                            <div className="mt-3 signature_container" style={{ position: 'relative' }}>
                                <SignatureCanvas penColor='black' ref={(ref) => { this.sigPad = ref }} onEnd={() => this.saveSignature()}
                                    canvasProps={{ width: 500, height: 200, className: 'sigCanvas' }} />
                                <div
                                    className="clear_signature_button"
                                    onClick={() => { this.clear() }}
                                >Clear</div>
                            </div>
                            <div className="mt-3">
                                <AppSelectField
                                    title={'Place of Signing'}
                                    value={this.state.placeOfSigning}
                                    placeholder={'Select state...'}
                                    options={this.state.stateList || []}
                                    fieldNames={{ label: ('reference1'), value: ('code') }}
                                    onChange={(e) => this.setState({ placeOfSigning: e })}
                                />
                            </div>
                            <div className="mt-3 ">
                                <Checkbox
                                    onChange={(e) => this.handleChecked(e.target.checked)}
                                    value={this.state.confirmSignature}
                                >
                                    I confirm and declare that the signature in the signature box above is my signature and is for mortgage takaful application. I also declare that I fully understand and agree with all the information and declarations in the attached documents, i.e. the Proposal Form and Product Illustration Sheet.
                                </Checkbox>
                            </div>

                        </div>
                    </div>
                    {this.showMessageModal()}
                    <AppModal
                        open={this.state.cancelModalOpen}
                        handleModalClose={() => this.handleCancelModalClose()}
                        // width={'100%'}
                        title={'Do you want to cancel?'}
                        subtitle={'If you cancel, you might loose any progress you\'ve made.'}
                        negativeButtonText={'Yes, Cancel'}
                        positiveButtonText={'No, Continue'}
                        handleNegativePress={() => this.handleCancelReview()}
                        handlePositivePress={() => this.handleCancelModalClose()}
                        closable={false}
                    />
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
});

export default withRouter(connect(mapStateToProps)(ReviewSignature));
